import type { UiStrings } from '../i18n/types'

/** Minimal UI surface for the honest pot amount label. */
export type PotLabelUi = Pick<UiStrings, 'summaryPot'>

/**
 * Softwise M10d: pot AMOUNT only. The HU / multiway label lives in one place
 * (potShape.shareProcessKind); the old `HU` / `N-way` / `Pot shape · HU`
 * token path is gone.
 */
export type PotDisplayParts = {
  amountBb: number | null
  /** Compact amount e.g. "12bb" */
  amountLabel: string | null
  /** Localized L1 (`Pot 12bb`); null when no amount or no ui */
  combinedL1: string | null
  /** Pro meta: "pot 12bb"; null when no amount */
  combinedPro: string | null
}

function formatAmountBb(n: number): string {
  if (Number.isInteger(n)) return String(n)
  const s = n.toFixed(2).replace(/\.?0+$/, '')
  return s || String(n)
}

/** Pass `ui` for the localized L1; omit for pro-only (`combinedPro`). */
export function formatPotDisplay(
  potBb: number | null | undefined,
  ui?: PotLabelUi,
): PotDisplayParts {
  const amountBb =
    potBb != null && Number.isFinite(potBb) && potBb >= 0 ? potBb : null
  const amountLabel = amountBb != null ? `${formatAmountBb(amountBb)}bb` : null
  return {
    amountBb,
    amountLabel,
    combinedL1: ui && amountBb != null ? ui.summaryPot(amountBb) : null,
    combinedPro: amountLabel ? `pot ${amountLabel}` : null,
  }
}
